module.exports = __webpack_public_path__ + "img/add-image2.7f91d426.png";